
(function ($) {

    function parallax(element,fix,ratio) {

        let scroll = window.scrollY;
        let offset = $(window).height() - $("header").height();
        let elementPos = element.position().top - $("header").height();
        let xpos = (((scroll + offset) - (elementPos)) * ratio)-fix;
        element.css("background-position", 'center ' + xpos + 'px');

        window.addEventListener('scroll',function(e){

            offset = $(window).height() - $("header").height();
            elementPos = element.position().top - $("header").height();
            scroll = window.scrollY;
            xpos = (((scroll + offset) - (elementPos)) * ratio)-fix;

            if(xpos<0){
                element.css("background-position", 'center ' + xpos + 'px');
            }

        })

    }

    function scrollElement(parent, child, animation, delay) {


        let scroll = window.scrollY;
        let offset = ($(window).height() - $("header").height()) / 2;

        let element = (child) ? parent.find(child) : parent;
        element.addClass(animation).addClass('start').addClass('inactive');
        let elementH = (child) ? parent.height() : element.height();

        let parentPos = (child) ? parent.offset().top : element.offset().top - (elementH / 2) - $("header").height();
        let xpos = scroll + offset - parentPos;

        if (xpos > 0) {
            element.removeClass('start').addClass('end');
        }

        if (xpos + (offset) < 0) {
            element.removeClass('end').addClass('start');
        }

        element.css('transition-delay', delay + 's');

        window.addEventListener('scroll',function(e){

            scroll = window.scrollY;
            offset = ($(window).height() - $("header").height()) / 2;
            xpos = scroll + offset - parentPos;
            element.addClass(animation).addClass('start');
            

            if (xpos > 0) {
                if(!element.hasClass('active')){
                    element.removeClass('inactive').addClass('active').removeClass('start').addClass('end');
                    // console.log(element, xpos);
                }
            }

            if (xpos + (offset) < 0) {
                if(!element.hasClass('inactive')){
                    element.removeClass('active').addClass('inactive').removeClass('end').addClass('start');
                    // console.log(element, xpos);
                }
                
            }

        });

    }

    module.exports = {
        parallax: parallax,
        scrollElement: scrollElement,
    }
})(jQuery)